import {call, put, takeLatest, fork, all, delay} from 'redux-saga/effects';
import * as Types from '../types/Company';
import * as Func from "../../utils/functions";
import {parseListRequestParams} from '../../utils/commonUtils';
import * as FunctionService from '../services/companyService';
import * as FunctionAction from '../actions/companyAction';
import {message} from "antd";
import CompanyRequest, {filtersParams} from "../mapping/Request/CompanyRequest";
import TAG_DEFINE from "../../constants/common";
import PERMISSION from "../../constants/permission";

function* actionGetListCompany() {
    yield takeLatest(Types.COMPANY_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(filtersParams(action.filters || {}));
        const result = yield call(FunctionService.getListCompany, params);
        yield put(FunctionAction.companyListSuccess(result));
    }, errorHandle(Types.COMPANY_FAILED)))
}

function* actionGetItem() {
    yield takeLatest(Types.COMPANY_GET_TEM_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(FunctionService.getItem, action.params.id);
        yield put(FunctionAction.companyGetItemSuccess(result));
    }, errorHandle(Types.COMPANY_FAILED)))
}

function* actionGetMasterCompany() {
    yield takeLatest(Types.COMPANY_MASTER_DATA_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(FunctionService.masterData, action.params);
        yield put(FunctionAction.companyMasterDataSuccess(result));
    }, errorHandle(Types.COMPANY_FAILED)))
}

function* createAction() {
    yield takeLatest(Types.COMPANY_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const data = new CompanyRequest(action.params).exportCreate();
        const result = yield call(FunctionService.create, data);
        message.success(TAG_DEFINE.VALIDATION.statusCode.code["201"]);
        action.params.props.history.push(PERMISSION.COMPANY.VIEW.route, {group: PERMISSION.COMPANY.VIEW.group});
        yield put({ type: Types.COMPANY_LIST_ACTION });
    }, errorHandle(Types.COMPANY_FAILED)))
}

function* updateAction() {
    yield takeLatest(Types.COMPANY_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const data = new CompanyRequest(action.params).exportUpdate();
        yield call(FunctionService.update, data);
        message.success(TAG_DEFINE.VALIDATION.statusCode.code["204"]);
        yield put(FunctionAction.companyGetItemAction({id: action.params.id}));
    }, errorHandle(Types.COMPANY_FAILED)))
}

function errorHandle(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({type: errorActionType, errors: e?.errors})
    });
}

export function* companySaga() {
    yield all([
        fork(actionGetListCompany),
        fork(createAction),
        fork(actionGetMasterCompany),
        fork(actionGetItem),
        fork(updateAction),
    ])
}
